export enum CloudFunctions {
  SetUserInformation = 'setUserInformation',
  CreateOrganization = 'createOrganization',
  InviteOrganizationMembers = 'inviteOrganizationMembers',
  AcceptOrganizationInvitation = 'acceptOrganizationInvitation',
  ListOrganizationMembers = 'listOrganizationMembers',
  UpdateOrganizationUserRole = 'updateOrganizationUserRole',
  // LeaveOrganization = 'leaveOrganization',
  // RemoveUserFromOrganization = 'removeUserFromOrganization',
  CreateWorkspace = 'createWorkspace',
  GrantUserAccessToWorkspace = 'grantUserAccessToWorkspace',
  UpdateUserAccessToWorkspace = 'updateUserAccessToWorkspace',
  RevokeUserAccessToWorkspace = 'revokeUserAccessToWorkspace',
  DeleteWorkspace = 'deleteWorkspace',
}
